import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, empty } from 'rxjs';

import { Fund } from '@models/fund.model';
import { environment } from '@env/environment';
import { Client } from '@app/features/master/create-user/master-create-user-model';
const BASE_PATH = environment.basePath;
/**
 * Service class to communicate with the REST services
 */
@Injectable({
    providedIn: "root"
})
export class ClientService {

    constructor(private httpClient: HttpClient) { }
    /**
* Retorna informações do cliente
* @param {any} institutionId institutionId 
* @return {Observable<Client>} 
*/


    getClientByClientId(institutionId?: any): Observable<Client> {
        // verify required parameters are not null or undefined
        if (institutionId === null || institutionId === undefined) {
            return throwError('Required parameter institutionId was null or undefined.');
        }
        let params = new HttpParams();
        params = params.append('institutionId', institutionId.toString());

        return this.httpClient.get<Client>(`${BASE_PATH}/bff/clients/view/`, { params: params });
    }
    /**
    * Retorna uma lista de clientes (MOCK)
    * @return {  Observable<Fund[]>} 
    */
    getFundByClientIdUsingGET(): Observable<Fund[]> {

        return this.httpClient.get<Fund[]>(`${BASE_PATH}/bff/clients/view/{uuid}/funds`);
    }

    /**
    * Retorna uma lista de clientes (MOCK)
    * @param {Client} filter filter clients
    * @return {  Observable<Client[]>} 
    */
    listUsingPOST(filter?: Client[]): Observable<Client[]> {
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        return this.httpClient.post<Client[]>(`${BASE_PATH}/bff/createUserConfig/clients`, filter, { headers: headers });
    }

    listAllClients(): Observable<Client[]> {
        const headers = new HttpHeaders({ "Content-Type": "application/json" });
        return this.httpClient.get<Client[]>(`${BASE_PATH}/bff/clients`, { headers: headers });
    }
    getClients(): Observable<any> {
        return this.httpClient.get<any[]>(
          `${BASE_PATH}/bff/master/clients`
        );
      }
    /**
    * Retorna uma lista de ddis (MOCK)
    * @return {  Observable<any[]>} 
    */
    listDDIs(): Observable<any[]> {
        return this.httpClient.get<any[]>(`${BASE_PATH}/bff/createUserConfig/ddis`);
    }
}
